import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function CustomerTestimonials() {
  const testimonials = [{
    name: 'Sarah M.',
    location: 'Caversham',
    rating: 5,
    text: "The staff at Better Pets really know their stuff. They helped me find the perfect food for my senior dog's sensitive stomach. Wouldn't shop anywhere else!",
    avatar: '👩'
  }, {
    name: 'James T.',
    location: 'Malaga',
    rating: 5,
    text: 'Great range of pool chemicals and the free water testing service is brilliant. Saved me so much hassle trying to balance my pool myself.',
    avatar: '👨'
  }, {
    name: 'Linda K.',
    location: 'Whitfords',
    rating: 5,
    text: 'Love the Customer Care Club! The points add up quickly and the member prices make a real difference on our monthly pet food budget.',
    avatar: '👩'
  }];
  return <section className="section-padding bg-warm-50" data-id="element-47">
      <div className="container-wide" data-id="element-48">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-49">
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-4" data-id="element-50">
            Loved by WA Locals
          </h2>
          <p className="text-lg text-gray-600" data-id="element-51">
            Don't just take our word for it. Here's what our community has to
            say about the Better Pets and Gardens experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-52">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 relative" data-id="element-53">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-warm-200" data-id="element-54" />

              <div className="flex items-center gap-1 mb-4" data-id="element-55">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-56" />)}
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-57">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-100" data-id="element-58">
                <div className="w-12 h-12 rounded-full bg-brand-blue-50 flex items-center justify-center text-2xl" data-id="element-59">
                  {testimonial.avatar}
                </div>
                <div data-id="element-60">
                  <div className="font-heading font-bold text-gray-900" data-id="element-61">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-62">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}